import { useSelector } from 'react-redux';
import { standortUrlSelector } from '../modules/selectors/url';
import { useLocation, useHistory } from 'react-router-dom';
import { apiClient } from './apiHelperV2';
import { useEffect, useState } from 'react';

export default function useRedirectCheck() {
    const standortUrl = useSelector(standortUrlSelector);
    const location = useLocation();
    const history = useHistory();
    const [resolved, setResolved] = useState(false);

    useEffect(() => {
        if (typeof window === 'undefined') return;

        const checkRedirect = async () => {
            try {
                const res = await apiClient.get(`/api/v1/standorte/${standortUrl}/redirects`);
                const redirects = res?.data?.data;

                if (redirects) {
                    const currentHref = window.location.href;
                    const redirect = redirects.find(r => r.oldUrl === currentHref);

                    if (redirect) {
                        console.log(`Redirecting (${redirect.statusCode}) to`, redirect.newUrl);
                        try {
                            const targetUrl = new URL(redirect.newUrl, window.location.origin);
                            if (targetUrl.origin === window.location.origin) {
                                const relativePath = targetUrl.pathname + targetUrl.search + targetUrl.hash;
                                if (redirect.statusCode === 301 || redirect.statusCode === 302) {
                                    history.replace(relativePath);
                                } else {
                                    history.push(relativePath);
                                }
                            } else {
                                window.location.href = redirect.newUrl;
                            }
                        } catch (e) {
                            console.error('Invalid redirect URL:', redirect.newUrl, e);
                        }
                        return; // stop further rendering
                    }
                }
            } catch (e) {
                console.error('Redirect check failed', e);
            } finally {
                setResolved(true); // redirect check finished
            }
        };

        checkRedirect();
    }, [standortUrl, location.pathname, history]);

    return resolved;
}
